// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-y: auto;
  /* leave room for left sidebar (narrow vertical sidebar) */
  margin-left: 72px;
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

.Home::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, and Opera */
}

.Home>* {
  flex: 1 1;
}

.About {
  background-color: white;
  min-height: 100vh;
  padding: 20px;
  position: relative;
  z-index: 1;
}

.About-header {
  text-align: center;
  margin-top: 50px;
}

.Footer {
  flex-shrink: 0;
}

/* Section divider between banner and the following page section */
.SectionDivider {
  width: 100%;
  height: 14px; /* thicker */
  margin: 0;
  /* solid dark grey bar with a subtle top highlight for depth */
  background: linear-gradient(180deg, #3a3a3a, #2a2a2a);
  border-top: 1px solid rgba(255,255,255,0.03);
  box-shadow: none;
  /* keep a tiny blur for polish on capable browsers */
  backdrop-filter: blur(2px) saturate(100%);
  -webkit-backdrop-filter: blur(2px) saturate(100%);
}

@media (max-width: 768px) {
  .SectionDivider {
    height: 10px;
    box-shadow: none;
  }
}

/* On small screens, remove left margin and let nav collapse to top */
@media (max-width: 768px) {
  .Home {
    margin-left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/Home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,0DAA0D;EAC1D,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,WAAW;EACX,YAAY,EAAE,YAAY;EAC1B,SAAS;EACT,8DAA8D;EAC9D,qDAAqD;EACrD,4CAA4C;EAC5C,gBAAgB;EAChB,oDAAoD;EACpD,yCAAyC;EACzC,iDAAiD;AACnD;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA,qEAAqE;AACrE;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".Home {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  overflow-y: auto;\n  /* leave room for left sidebar (narrow vertical sidebar) */\n  margin-left: 72px;\n  -ms-overflow-style: none;\n  /* IE and Edge */\n  scrollbar-width: none;\n  /* Firefox */\n}\n\n.Home::-webkit-scrollbar {\n  display: none;\n  /* Chrome, Safari, and Opera */\n}\n\n.Home>* {\n  flex: 1;\n}\n\n.About {\n  background-color: white;\n  min-height: 100vh;\n  padding: 20px;\n  position: relative;\n  z-index: 1;\n}\n\n.About-header {\n  text-align: center;\n  margin-top: 50px;\n}\n\n.Footer {\n  flex-shrink: 0;\n}\n\n/* Section divider between banner and the following page section */\n.SectionDivider {\n  width: 100%;\n  height: 14px; /* thicker */\n  margin: 0;\n  /* solid dark grey bar with a subtle top highlight for depth */\n  background: linear-gradient(180deg, #3a3a3a, #2a2a2a);\n  border-top: 1px solid rgba(255,255,255,0.03);\n  box-shadow: none;\n  /* keep a tiny blur for polish on capable browsers */\n  backdrop-filter: blur(2px) saturate(100%);\n  -webkit-backdrop-filter: blur(2px) saturate(100%);\n}\n\n@media (max-width: 768px) {\n  .SectionDivider {\n    height: 10px;\n    box-shadow: none;\n  }\n}\n\n/* On small screens, remove left margin and let nav collapse to top */\n@media (max-width: 768px) {\n  .Home {\n    margin-left: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
